import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { UNIT } from '../types/unit.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Unit (Unidade de medida).
 * Stored in 'org/{orgId}/unit'.
 *
 * Catalog only — no FK from Product. `Product.unit` stays a free string;
 * `Unit` supplies the default for `Product.quantityDecimals` at edit time
 * (spec 0032 §3 / request 0095).
 */
export const unitDescriptor = {
    name: UNIT,
    label: 'Unidade de medida',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/unit',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Catálogo de unidades de medida (código, descrição, casas decimais default)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique unit identifier',
        },
        {
            name: 'code',
            example: 'KG',
            label: 'Código',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.UNIT,
            description: 'Unit code typed on products (e.g. KG, PAR, M)',
        },
        {
            name: 'description',
            example: 'Quilograma',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Full unit name (e.g. Quilograma, Par)',
        },
        {
            name: 'quantityDecimals',
            example: 3,
            label: 'Casas decimais',
            type: 'number',
            required: true,
            description: 'Default decimal places for quantities in this unit (0–4). Copied to Product.quantityDecimals when the unit code matches at edit time — not a runtime authority.',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=unit.descriptor.js.map